import { Deferred } from '@/shared/libs';
import { AssetLoader } from '@/shared/utils';

const AUTOPLAY_FAIL_TIMEOUT = 1000;

export default async ({ $deferredLoader, $services }, inject) => {
  const info = $services.resolve('info');

  await info.fetch();
  const playerUrl = info.playerUrl;
  $deferredLoader.player = new Deferred();
  $deferredLoader.player.promise.catch(() => {});

  inject('redGalaxyPlayer', {
    createInstance(video, signal = {}) {
      return $deferredLoader.player.promise.then(() => {
        if (signal.aborted) {
          return Promise.resolve();
        }

        if (!window.redGalaxy || !window.redGalaxy.Player) {
          return Promise.reject();
        }

        return new window.redGalaxy.Player(video);
      });
    },
    checkAutoplay() {
      if (!window.redGalaxy || !window.redGalaxy.Player) {
        return Promise.reject();
      }

      const { checkAutoplayFailTimeout = AUTOPLAY_FAIL_TIMEOUT } = info.platformSettings;
      return window.redGalaxy.Player.utils.checkAutoplaySupport(checkAutoplayFailTimeout);
    },
  });

  if (!playerUrl) {
    $deferredLoader.player.resolve();
    return;
  }

  $deferredLoader.appReady.promise
    .then(() => new AssetLoader().load([
      { id: 'player', src: playerUrl },
    ]))
    .then(() => $deferredLoader.player.resolve())
    .catch(() => $deferredLoader.player.reject());
};
